/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import { SettingsApi, Settings, Tag } from '@api/model';
import { DefaultHttpService } from './HttpService';

class SettingsService {
  readonly settingsApi = new SettingsApi(new DefaultHttpService());

  public getSettings(): Promise<Settings> {
    return this.settingsApi.getSettings();
  }

  public updateSettings(settings: Settings): Promise<any> {
    return this.settingsApi.updateSettings(settings);
  }

  public getTags(): Promise<Tag[]> {
    return this.settingsApi.getTags();
  }
}

export default new SettingsService();
